export enum CourseType {
	HomeFilterCoffee = "HomeFilterCoffee",
	HomeEspresso = "HomeEspresso",
	SCAFoundation = "SCAFoundation",
	SCAIntermediate = "SCAIntermediate",
}
